import React from 'react';
import { GridLoader, PropagateLoader } from 'react-spinners';

const LoaderCover = () => {
 

  return (
    <div className="loader-cover">
     <PropagateLoader
            color={"#8dc07a"}
            loading={true}
            size={30}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
          </div>
  );
};

export default LoaderCover;
